/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BPicture, BVideo } from 'react-bigpicture';
import { LOADING_COLOR } from 'dash-front/constants';
import { POST_STEPS, STATUS_STATES } from '../../../../../config/postConstants';
import CircularProgress from 'material-ui/CircularProgress';
import ErrorIcon from 'material-ui/svg-icons/alert/error-outline';
import ImageIcon from 'material-ui/svg-icons/image/crop-original';
import { red500 } from 'material-ui/styles/colors';

const Wrapper = styled.div`
    ${({ width }) => width && `max-width: ${typeof width === 'number' ? width + 'px' : width}`};
    ${({ height }) => height && `height: ${typeof width === 'number' ? height + 'px' : height}`};

    background-color: ${LOADING_COLOR};
`;

const NotImage = Wrapper.extend`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Img = styled.img`
    display: block;
    width: 100%;
    ${({ width }) => width && `max-width: ${typeof width === 'number' ? width + 'px' : width}`};
    height: auto;

    object-fit: contain;
`;

const isVideo = (src = '') => {
    const extension = src.split('.');

    return ['mp4'].includes(extension[extension.length - 1]);
};

export const isContentGenerationPost = ({ step = '' }) => step === POST_STEPS.CONTENT_GENERATION;

export const isPostFailed = ({ step = '', state = '' }) =>
    step !== POST_STEPS.AWAITING_FOR_MODERATION && state === STATUS_STATES.FAILED;

function PostImage({ post = {}, width = '100%', height, iconWidth = 34, iconHeight = 34 }) {
    const loaded = Boolean(post);

    if (!loaded) {
        return (
            <NotImage width={width} height={height}>
                <ImageIcon style={{ width: iconWidth, height: iconHeight }} />
            </NotImage>
        );
    }

    const { content = {}, status = {} } = post;

    const imageSrc = content.picture;
    const videoSrc = content.video;

    if (!imageSrc) {
        return (
            <NotImage width={width} height={height}>
                {isContentGenerationPost(status) && !isPostFailed(status) ? (
                    <CircularProgress size={iconWidth} />
                ) : (
                    <ErrorIcon style={{ width: iconWidth, height: iconHeight }} color={red500} />
                )}
            </NotImage>
        );
    }

    if (!isVideo(videoSrc || imageSrc)) {
        return (
            <BPicture src={imageSrc}>
                <Img src={imageSrc} width={width} alt="Post Image" />
            </BPicture>
        );
    }

    return (
        <BVideo src={videoSrc}>
            <video
                style={{ width, height }}
                onError={e => {
                    const videoElement = e.currentTarget;
                    videoElement.style.display = 'none';
                    videoElement.parentElement.style.background = '#f9f9f9';
                }}
                loop
                autoPlay
                controls="controls"
            >
                <source src={videoSrc} />
            </video>
        </BVideo>
    );
}

PostImage.propTypes = {
    post: PropTypes.shape({
        status: PropTypes.shape({
            step: PropTypes.string,
            state: PropTypes.string,
        }),
        content: PropTypes.shape({
            picture: PropTypes.string,
            message: PropTypes.string,
        }),
    }).isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    iconWidth: PropTypes.number,
    iconHeight: PropTypes.number,
};

export default PostImage;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Posts/PostImage.js
 **/